export default "__VITE_ASSET__CVC6WJGL__"